import { all, takeLatest, call, put } from 'redux-saga/effects';

import { objParser } from '@snapask/common-components/dist/utils/objCamelcaseParser';

import { types, actions } from '@blueberry/redux/profile';
import { actions as errorActions } from '@blueberry/redux/error';

import { appLaunch } from '@blueberry/services/apis';

export function* fetchUserFlow() {
  try {
    const { user } = yield call(appLaunch);
    // Only student has gradeName property
    const {
      schoolName,
      gradeLevel: { name: gradeName } = {},
      role: { name: role },
      region: { name: region } = {},
      ...transformedUser
    } = objParser(user);

    yield put(
      actions.fetchUserSuccess({
        ...transformedUser,
        region,
        schoolName,
        gradeName,
        role,
      })
    );
  } catch (error) {
    yield put(errorActions.sendError(error));
    yield put(actions.fetchUserFailure(error));
  }
}

export default function*() {
  yield all([takeLatest(types.FETCH_USER, fetchUserFlow)]);
}



// WEBPACK FOOTER //
// ./app/sagas/profile.js